/**
 * 모든 스토어를 초기화하는 공통 함수
 * 로그아웃 시 호출하여 모든 상태를 리셋
 */

import { initializeAllStores } from '../menu/storeInitializer';
import { resetAllColumnStates } from '../grid/resetAllColumnStates';

export const resetAllStores = () => {
  try {
    console.log('🔄 모든 MES 모듈 스토어 초기화 시작...');

    // === 모든 스토어 초기화 (tabInitializer 재사용) ===
    initializeAllStores();

    // === 로컬스토리지에서 그리드 컬럼 상태 제거 ===
    // 하드코딩 목록 대신 패턴 매칭 유틸로 일괄 제거 (신규 화면 누락 방지)
    resetAllColumnStates();

    console.log('✅ 모든 MES 모듈 스토어가 성공적으로 초기화되었습니다.');
  } catch (error) {
    console.error('❌ 스토어 초기화 중 오류 발생:', error);
  }
};
